import React from 'react';
import { SpriteSvg } from 'project/sprite-svg';
import { GRANTED, REACT_APP_ENDEAVOR_VIDEO_BASE_URL } from '../../../general/js/api/endeavor/constants/api-constants';
import { getFormattedDuration } from './date-utils';
import { AccessDeniedView } from '../../endeavor-player/js/components/access-denied-view';

const EndeavorLink = ({ vod }) => {
    const content = (
        <img
            src={vod.thumbnailUrl}
            className="endeavor-playlist__tile-thumb-img"
            alt={vod.title || ''}
        />
    );

    if (vod.accessLevel === GRANTED) {
        return (
            <a
                href={`${REACT_APP_ENDEAVOR_VIDEO_BASE_URL}/${vod.id}`}
                className="endeavor-playlist__tile-link"
            >
                {content}
            </a>
        );
    }

    return (
        <>
            <AccessDeniedView accessLevel={vod.accessLevel} />
            {content}
        </>
    );
};

const EndeavorPlaylistTile = ({ vod }) => {
    return (
        <div className="endeavor-playlist__tile">
            <div className="endeavor-playlist__tile-thumb-wrapper">
                <EndeavorLink vod={vod} />

                <div className="endeavor-playlist__tile-play-icon">
                    <SpriteSvg
                        iconName="play"
                        width={40}
                        height={40}
                        viewBox="0 0 24 24"
                    />
                </div>

                <div className="endeavor-playlist__tile-duration">
                    {vod.duration && getFormattedDuration(vod.duration)}
                </div>
            </div>

            <div className="endeavor-playlist__tile-title">
                {vod.title}
            </div>
        </div>
    );
};

export default EndeavorPlaylistTile;
